// Hook
import { useProgram } from '../../hooks/useProgram';

// Components
import EventModal from '../../components/program/EventModal';
import ProgramDaySheet from '../../components/program/ProgramDaySheet';
import ProgramHeader from '../../components/program/ProgramHeader';
import ProgramList from '../../components/program/ProgramList';
import ProgramSkeleton from '../../components/program/ProgramSkeleton';
import ProgramTimeline from '../../components/program/ProgramTimeline';

export default function Program() {
    const program = useProgram();

    if (!program.isReady) return <ProgramSkeleton />;

    return (
        <div className="program">
            <ProgramHeader
                selectedCategory={program.selectedCategory}
                selectedDayLabel={program.selectedDayLabel}
                selectedDate={program.selectedDate}
                selectedDateIndex={program.selectedDateIndex}
                viewMode={program.viewMode}
                isDayPickerOpen={program.isDayPickerOpen}
                isDayDropdownOpen={program.isDayDropdownOpen}
                uniqueDates={program.uniqueDates}
                categoryAvailability={program.categoryAvailability}
                dayLabelBtnRef={program.dayLabelBtnRef}
                dropdownRef={program.dropdownRef}
                setSelectedCategory={program.setSelectedCategory}
                setSelectedDate={program.setSelectedDate}
                setIsDayDropdownOpen={program.setIsDayDropdownOpen}
                openDayPicker={program.openDayPicker}
                goPrevDay={program.goPrevDay}
                goNextDay={program.goNextDay}
                setViewModeAndPersist={program.setViewModeAndPersist}
            />

            {program.viewMode === 'list' ? (
                <ProgramList
                    listEvents={program.listEvents}
                    onOpenModal={program.handleOpenModal}
                />
            ) : (
                <ProgramTimeline
                    timeSlots={program.timeSlots}
                    stageHeightPx={program.stageHeightPx}
                    timelineEvents={program.timelineEvents}
                    timeWindow={program.timeWindow}
                    onOpenModal={program.handleOpenModal}
                />
            )}

            <ProgramDaySheet
                isOpen={program.isDayPickerOpen}
                uniqueDates={program.uniqueDates}
                selectedDate={program.selectedDate}
                onClose={() => program.setIsDayPickerOpen(false)}
                onSelectDate={dk => {
                    program.setSelectedDate(dk);
                    program.setIsDayPickerOpen(false);
                }}
            />

            {program.modalEvent && (
                <EventModal
                    event={program.modalEvent}
                    onClose={program.handleCloseModal}
                    isClosing={program.isModalClosing}
                />
            )}
        </div>
    );
}
